import localizeFilter from "@/filters/localizeFilter";

export default localizeFilter("MessagesMap");
